import { Functions, httpsCallable } from '@angular/fire/functions';
import { CreateAdminUserRequest, CreateAdminUserResponse } from './create-admin-user.types';

export function onCallCreateAdminUser(functions: Functions) {
  return async (request: CreateAdminUserRequest) => {
    const fn = httpsCallable<CreateAdminUserRequest, CreateAdminUserResponse>(functions, 'onCallCreateAdminUser');
    const { data } = await fn(request);
    return data;
  };
}
